import { Button, message, Upload } from "antd";
import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { UploadFile } from "antd/es/upload/interface";

interface ImageItem {
  uid: string;
  name: string;
  status: UploadFile["status"];
  url: string;
  originFileObj?: File;
}

type Props = {
  image_name: string;
  field: string;
  setFieldValue: (field: string, value: any) => void;
  logoFileList: ImageItem[];
  setLogoFileList: (list: any[]) => void;
};

const SelectImage: React.FC<Props> = ({
  image_name,
  field,
  setFieldValue,
  logoFileList,
  setLogoFileList,
}) => {
  const getBase64 = (file: File, callback: (base64: string) => void) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result as string);
    reader.onerror = () => {
      message.error("Faylı yükləmək alınmadı.");
    };
  };

  return (
    <div className="input_wrapper">
      <Upload
        name={field}
        fileList={logoFileList as any[]}
        beforeUpload={(file) => {
          // File obyektini həm formik-ə, həm fileList-ə yazırıq
          setFieldValue(field, file);

          getBase64(file as File, (base64: string) => {
            setLogoFileList([
              {
                uid: file.uid,
                name: file.name,
                status: "done",
                url: base64,
                originFileObj: file as unknown as File,
              },
            ]);
          });

          // Avtomatik HTTP POST sorğusunun qarşısını alırıq
          return false;
        }}
        onRemove={() => {
          setFieldValue(field, null);
          setLogoFileList([]);
        }}
        showUploadList={false}
        maxCount={1}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {logoFileList.length > 0 && (
            <>
              <img
                src={logoFileList[0].url || ""}
                alt="page_image"
                style={{
                  width: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginTop: "10px",
                }}
              />
              <p
                style={{
                  margin: "8px 0 0",
                  fontSize: "14px",
                  color: "#555",
                }}
              >
                {logoFileList[0].name}
              </p>
            </>
          )}
          <Button icon={<UploadOutlined />}>{image_name}</Button>
        </div>
      </Upload>
    </div>
  );
};

export default SelectImage;